var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#6C69F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14001_4894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3327 12.3333H18.3327V11.14C18.3327 9.39997 17.0593 7.84664 15.326 7.67997C13.3393 7.4933 11.666 9.0533 11.666 11V12.3333H9.66602V21.6666H20.3327V12.3333ZM14.9993 18.3333C14.266 18.3333 13.666 17.7333 13.666 17C13.666 16.2666 14.266 15.6666 14.9993 15.6666C15.7327 15.6666 16.3327 16.2666 16.3327 17C16.3327 17.7333 15.7327 18.3333 14.9993 18.3333ZM12.9993 12.3333V11C12.9993 9.8933 13.8927 8.99997 14.9993 8.99997C16.106 8.99997 16.9993 9.8933 16.9993 11V12.3333H12.9993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14001_4894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.29547de20619692a1280f9331b5c7626.svg";
export { ForwardRef as ReactComponent };